import {classImplementsInterfaces, GAME_STAGE} from "@goodgamestudios/createjs-utilities";

import {
    BasicCheckMaintenanceCommand,
    BasicConnectToInstanceVOCommand,
    BasicController,
    BasicFrameOne,
    BasicModel,
    CommandController,
    EnvGlobalsHandler,
    GoodgameBitmapEngine,
    PathProvider,
    SMARTFOX_CLIENT,
    UncaughtErrorEventHandler
} from "@goodgamestudios/core";

import {InterfaceVersions, ItemVersions} from "@goodgamestudios/poker2-createjs-assets";

import {cascadeLogLevelFor, getLogger, LoggingLevel} from "@goodgamestudios/logger";
import {Poker2InitLoggerCommand} from "./controller/clientCommands/Poker2InitLoggerCommand";
import {Poker2InitServerListCommand} from "./controller/clientCommands/Poker2InitServerListCommand";
import {Poker2BackgroundComponent} from "./view/Poker2BackgroundComponent";

import {AssetUrlConvertor} from "./helper/AssetUrlConvertor";
import {fontConfigResolver} from "./helper/LanguageFontMap";
import {PokerGame} from "./PokerGame";
import {PokerAssetsLoader} from "./PokerAssetsLoader";

// Needed in CreateJS-Utilies so asset URL in spritesheet can be mapped correct (per game)
(window as any).AssetURL = new AssetUrlConvertor();

// Needed font config
(window as any).ggs.fontConfigResolver = fontConfigResolver;

const logger = getLogger("PokerFrameOne");

export class PokerFrameOne extends BasicFrameOne {
    private pokerAssetsLoader: PokerAssetsLoader;

    constructor() {
        super("Poker");

        this.name = GAME_STAGE;

        // Initally fill up the module cache / mapping (name to class)
        createjs.precacheModules(__webpack_require__);
        if (EnvGlobalsHandler.globals.isTest) {
            cascadeLogLevelFor("CoreJS", LoggingLevel.DEBUG);
            cascadeLogLevelFor("CreateJs", LoggingLevel.NONE);
            cascadeLogLevelFor("WorldAssignment", LoggingLevel.DEBUG);
            cascadeLogLevelFor("CreateJs.TextFields", LoggingLevel.NONE);
            cascadeLogLevelFor("CoreJS.TextFields", LoggingLevel.NONE);
            cascadeLogLevelFor("TextFields", LoggingLevel.NONE);
            cascadeLogLevelFor("undefined", LoggingLevel.NONE);
            cascadeLogLevelFor("CoreJS.PerformanceMonitoring", LoggingLevel.NONE);
            cascadeLogLevelFor("CoreJS.PerformanceMonitoringTrackingCommand", LoggingLevel.NONE);
            cascadeLogLevelFor("CreateJs.StageExtension", LoggingLevel.DEBUG);

            getLogger("CoreJS.TextFields.BasicLanguageFontManager").setLevel(LoggingLevel.DEBUG);
            getLogger("Connection.BasicCheckMaintenanceCommand").setLevel(LoggingLevel.DEBUG);
            getLogger("CreateJs.ExternalInterface").setLevel(LoggingLevel.DEBUG);
            getLogger("CoreJS.ExternalInterface").setLevel(LoggingLevel.DEBUG);
            getLogger("GoodgameTextField").setLevel(LoggingLevel.NONE);
            getLogger("getDefinitionByName").setLevel(LoggingLevel.NONE);
            getLogger("BasicFrameOne").setLevel(LoggingLevel.DEBUG);
            getLogger("DEPRECATED").setLevel(LoggingLevel.NONE);
            getLogger(SMARTFOX_CLIENT).setLevel(LoggingLevel.DEBUG);
            getLogger("Tracking.TrackingCache").setLevel(LoggingLevel.NONE);
            getLogger("PerformanceMonitoringExternalLogCommand").setLevel(LoggingLevel.NONE);
        }

    }

    protected isAddedToStageDone(): void {
        PathProvider.instance.itemVersions = ItemVersions.instance;
        PathProvider.instance.interfaceVersions = InterfaceVersions.instance;
        GoodgameBitmapEngine.instance.init(this.stage, false, BasicModel.basicLoaderData.assetLoader);
        UncaughtErrorEventHandler.init(this.loaderInfo, true);
        super.isAddedToStageDone();
    }

    protected registerCommands(): void {
        super.registerCommands();
    }

    protected initPreClientCommands(): void {
        CommandController.instance.registerCommand(BasicController.COMMAND_INIT_SERVERLIST, Poker2InitServerListCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_CONNECT_TO_INSTANCEVO, BasicConnectToInstanceVOCommand);
        CommandController.instance.registerCommand(BasicController.COMMAND_CHECK_MAINTENANCE, BasicCheckMaintenanceCommand);
    }

    /*
    protected loadXMLs(): void {
        super.loadXMLs();
        BasicModel.basicLoaderData.appLoader.addXMLLoader(BasicConstants.ITEM_XML_LOADER, (this.env as Poker2EnvironmentGlobals).itemXMLUrl, URLLoaderDataFormat.BINARY);
    }
    */

    /*
    protected initLanguage(): void {
        BasicModel.languageData = new Poker2LanguageDataPreload();
        BasicModel.languageData.loadLanguage(this.env.language);
    }*/

    protected get initLoggerCommandClass(): any {
        return Poker2InitLoggerCommand;
    }

    protected get mainGameClassName(): string {
        return "com.goodgamestudios.poker2.PokerGame";
    }

    protected getMainGameClass(): any {
        return PokerGame;
    }

    protected createView(): void {
        this.pokerAssetsLoader = new PokerAssetsLoader();
        window.setLoadingScreenProgress(35);
        this.pokerAssetsLoader.loadDefaultAssets()
            .then(() => {
                window.setLoadingScreenProgress(50);
                return this.pokerAssetsLoader.loadPrimaryAssets();
            })
            .then(() => {
                window.setLoadingScreenProgress(80);
                this.preloaderView = new Poker2BackgroundComponent(new Library.PokerTitle.PokerTitle());
                this.preloaderView.startProgressBar();

                return this.pokerAssetsLoader.loadSecondaryAssets();
            })
            .then(() => {
                window.setLoadingScreenProgress(95);
                this.onViewLoaded();
            });
    }
}

classImplementsInterfaces(PokerFrameOne, "Stage");

new PokerFrameOne();
